import { HStack, Box, Text } from '@chakra-ui/react'
import { useSpring } from 'react-spring'
import { useRouter } from 'next/router'

import { AnimatedBox, DEFAULT_SPRING_CONFIG } from '@/lib/springComponent'
import ScrollLink from '@/lib/scroll'

interface Props {
  label: string
  hash: string
}

function TabButton({ label, hash }: Props): React.ReactElement {
  const { pathname } = useRouter()

  const [styles, api] = useSpring(() => ({
    transform: 'scale(0, 1)',
    opacity: 0,
    config: DEFAULT_SPRING_CONFIG,
  }))

  return (
    <HStack
      onMouseEnter={() =>
        api.start({
          transform: 'scale(1, 1)',
          opacity: 1,
        })
      }
      onMouseLeave={() => {
        api.start({
          transform: 'scale(0, 1)',
          opacity: 0,
        })
      }}
      sx={{
        spacing: '0px',
        h: '28px',
        transition: 'all 150ms',
        color: 'primary.800',
        cursor: 'pointer',
        fontSize: 'sm',
      }}
    >
      <Box sx={{ position: 'relative', h: '100%', w: 'full', px: '16px' }}>
        <ScrollLink
          url={{ pathname: pathname, hash: hash }}
          scrollOption={{ offset: -90, duration: 500 }}
        >
          <Text sx={{ h: 'full', textAlign: 'center' }}>{label}</Text>
        </ScrollLink>
        <AnimatedBox
          style={styles}
          sx={{
            position: 'absolute',
            bg: 'currentColor',
            borderRadius: 'full',
            width: 'full',
            height: 1,
            bottom: 0,
            left: 0,
          }}
        ></AnimatedBox>
      </Box>
    </HStack>
  )
}

export default TabButton
